

















import { Vue, Component, Mixins } from "vue-property-decorator";

import _ from "lodash";
import moment from "moment";

import MyCommon from "@/mixins/common";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  option: any = {
    grid: {
      // width: '100%',
      // left: '3%',
      // right: '4%',
      // bottom: '3%',
      containLabel: true
    },
    legend: {
      data: ["羽约运动", "羽约场馆"]
    },
    tooltip: {
      trigger: "axis"
    },
    xAxis: {
      type: "category",
      data: []
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: [],
        name: "羽约运动",
        type: "line",
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      },
      {
        data: [],
        name: "羽约场馆",
        type: "line",
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      }
    ]
  };

  ei: any = {};

  async loadData(params?: any) {
    const res1 = await this.$store.dispatch("statistics/getDownload", params);
    if (res1 && res1.Data) {
      this.option.xAxis.data = [];
      this.option.xAxis.data = res1.Data.categories;
      this.option.series[0].data = [];
      this.option.series[1].data = [];
      // let data1: number[] = []

      for (const k in res1.Data.data0) {
        if (res1.Data.data0[k]) {
          this.option.series[0].data.push(res1.Data.data0[k]);
        } else {
          this.option.series[0].data.push(0);
        }
      }

      for (const k in res1.Data.data1) {
        if (res1.Data.data1[k]) {
          this.option.series[1].data.push(res1.Data.data1[k]);
        } else {
          this.option.series[1].data.push(0);
        }
      }

      // this.option.series[0].data = res1.Data.data
      // console.log(this.option);
    }
  }

  mounted() {
    this.loadData();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    // console.log('From: ', dates[0], ', to: ', dates[1]);
    // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    this.loadData({
      start_time: `${dateStrings[0]} 00:00:00`,
      end_time: `${dateStrings[1]} 23:59:59`
    });
  }
}
